var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-count-container"},[_c('span',{staticClass:"total-count"},[_vm._v("Total: "+_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }